export const queryKeys = {
  SPACES: 'spaces',
  FOLDERS: 'folders',
  LISTS: 'lists',
  TASKS: 'tasks',
}
